exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".first-text {\n  margin: 60px auto; }\n  .first-text p {\n    color: #777; }\n\n.wine {\n  display: block;\n  margin: 0 auto 2em; }\n\n.video {\n  position: relative; }\n  .video video {\n    width: 100%; }\n  .video .player {\n    position: absolute;\n    cursor: pointer;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    z-index: 2; }\n\n.accroche {\n  background: #f4f4f4; }\n\n.slogan {\n  font-size: 2em; }\n\n.logyou {\n  background: #1c1c1c;\n  color: white;\n  padding: 50px;\n  position: relative; }\n  .logyou .triangle {\n    border-top: 30px solid #f4f4f4;\n    border-left: 30px solid transparent;\n    border-right: 30px solid transparent;\n    width: 40px;\n    height: 40px;\n    background: transparent;\n    position: absolute;\n    top: 0;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n            transform: translateX(-50%); }\n\n.partnaire {\n  padding: 40px; }\n\n.homefoot {\n  margin-top: -200px;\n  display: block; }\n\n@media screen and (min-width: 768px) {\n  .first-text {\n    padding: 0 200px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Mustafa/Developpement/noxoe/src/components/home/home.component.scss
// module id = ../../../../../src/components/home/home.component.scss
// module chunks = main